import { Box, Typography, styled } from '@mui/material';

import { FONT_FAMILY } from '@/shared/ui/form-fields/fieldStyles';

export const StepperTrack = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  maxWidth: '43.75rem',
  margin: '0 auto',
});

export const StepperLine = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '1rem',
  left: '1.625rem',
  right: '1.625rem',
  height: 0,
  borderTop: `1px solid ${theme.palette.blue[300]}`,
}));

export const StepItem = styled(Box)({
  position: 'relative',
  width: '3.375rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
});

export const StepDotSlot = styled(Box)({
  width: '2rem',
  height: '2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StepDot = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'state',
})<{ state: 'active' | 'done' | 'todo' }>(({ theme, state }) => ({
  width: '1.5rem',
  height: '1.5rem',
  borderRadius: '50%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: state === 'todo' ? theme.palette.common.white : theme.palette.blue[500],
  border: state === 'todo' ? `1px solid ${theme.palette.blue[300]}` : 'none',
  ...(state !== 'todo' && {
    boxShadow: `0 0 0 4px ${theme.palette.blue[200]}, 0 1px 1.5px 4px rgba(0, 0, 0, 0.14)`,
  }),
}));

export const StepText = styled(Typography)(({ theme }) => ({
  fontFamily: FONT_FAMILY,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: 0,
  color: theme.palette.grey[950],
  whiteSpace: 'nowrap',
}));
